export default __webpack_public_path__ + "static/media/480_dummy2016-reiseblog01-de.3c16ed23.png";